import React from 'react';
import { Badge } from '../ui/Badge';
const features = [{
  title: 'Inscription & billetterie',
  description: "Formulaires personnalisés, types d'accès, emails automatiques"
}, {
  title: 'Agenda multi-sessions',
  description: 'Multi-pistes, agenda personnel, statut temps réel'
}, {
  title: 'Profils intervenants',
  description: 'Photo, bio, sessions liées, notifications'
}, {
  title: 'Répertoire participants',
  description: 'Filtrable par pays, rôle, entreprise'
}, {
  title: 'Réservation réunions 1:1',
  description: 'Calendrier, sync Google/Outlook, timezone-aware'
}, {
  title: 'Speed networking',
  description: "File d'attente live, appairages aléatoires"
}, {
  title: 'Gestion exposants',
  description: 'Profil exposant, visibilité égale, pas de tiers'
}, {
  title: 'Messages directs',
  description: '1:1 temps réel, historique conservé'
}, {
  title: 'Fil communautaire',
  description: 'Posts, annonces, salons thématiques'
}, {
  title: 'Analytics avancés',
  description: 'Présence, networking, engagement, exportable'
}, {
  title: 'Live streaming',
  description: 'Intégration YouTube intégrée'
}, {
  title: 'White-label complet',
  description: 'Votre marque, URL, couleurs — UPOUI invisible'
}];
export function AvailableTodaySection() {
  return <section className="w-full py-20 md:py-24 relative font-heading" style={{
    backgroundColor: '#09090B'
  }} data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-126">
            Ce que MeetOS fait aujourd'hui
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-127">
          {features.map((feature, index) => <div key={index} className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-6 flex flex-col items-start hover:bg-white/[0.05] transition-colors" data-id="element-128">
              <Badge className="mb-4 bg-emerald-500/10 text-emerald-400 border-emerald-500/20 hover:bg-emerald-500/20 px-3 py-1 text-xs font-mono uppercase tracking-wider rounded-full" data-id="element-129">
                Disponible
              </Badge>
              <h3 className="text-xl font-semibold text-white mb-3" data-id="element-130">
                {feature.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-131">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}